export default __webpack_public_path__ + "static/portrait-6026eac0b92fe386122074e0a131760a.jpg";